module.exports = __webpack_public_path__ + "static/media/442GriffinStNW_2018-06-05_34.00a2880c.jpg";